import React, { useState } from "react";
import classes from "./blogsFilterPage.module.css";
import { SearchInput } from "../../../component/shared/formElements/searchInput/SearchInput";
import { useNavigate } from "react-router-dom";

export const BlogsFilterPage = () => {
  const [searchText, setSearchText] = useState("");
  const navigate = useNavigate();

  const handleSearch = (value) => {
    setSearchText(value);
    // API call / filter logic goes here
    console.log("Searching blogs for:", value);
  };

  const handleClear = () => {
    setSearchText("");
    // Reset list / refetch blogs
    console.log("Search cleared");
  };
  const handleAddBlog = () => {
    navigate("/blogs/add");
  };

  return (
    <div className={classes.box}>
      <div className={classes.box__content}>
        <SearchInput
          placeholder="Search blogs"
          value={searchText}
          onChange={setSearchText}
          onSearch={handleSearch}
          onClear={handleClear}
        />
      </div>

      <button className={classes.box__btn} onClick={handleAddBlog}>Create Blog</button>
    </div>
  );
};
